export function initPagedSlider(root, options = {}) {
    if (!root) {
        return null;
    }

    const selectors = {
        viewport: options.viewportSelector || '[data-slider-viewport]',
        track: options.trackSelector || '[data-slider-track]',
        controls: options.controlsSelector || '[data-slider-controls]',
        prev: options.prevSelector || '[data-slider-prev]',
        next: options.nextSelector || '[data-slider-next]',
        dots: options.dotsSelector || '[data-slider-dots]',
        slide: options.slideSelector || '.calcimo-slider__slide',
    };
    const dotClassName = options.dotClass || 'calcimo-slider__dot';
    const visibleSlides = options.visibleSlides || ((width) => (width >= 1200 ? 3 : (width >= 768 ? 2 : 1)));
    const hideControlsAt = options.hideControlsAtWidth ?? 1200;

    const viewport = root.querySelector(selectors.viewport);
    const track = root.querySelector(selectors.track);
    const controls = root.querySelector(selectors.controls);
    const prevButton = root.querySelector(selectors.prev);
    const nextButton = root.querySelector(selectors.next);
    const dotsNode = root.querySelector(selectors.dots);

    if (!viewport || !track || !controls || !prevButton || !nextButton || !dotsNode) {
        return null;
    }

    const slides = Array.from(track.querySelectorAll(selectors.slide));
    if (slides.length === 0) {
        return null;
    }

    let activeIndex = 0;
    let pageCount = 1;

    const createDots = () => {
        dotsNode.innerHTML = '';
        for (let index = 0; index < pageCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = dotClassName;
            dot.dataset.sliderDot = 'true';
            dot.setAttribute('aria-label', options.dotLabel ? options.dotLabel(index) : `Slide ${index + 1}`);
            dot.addEventListener('click', () => {
                activeIndex = index;
                render();
            });
            dotsNode.appendChild(dot);
        }
    };

    const updateControls = () => {
        const dots = Array.from(dotsNode.querySelectorAll('[data-slider-dot="true"]'));
        dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
        });

        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= pageCount - 1;
    };

    const render = () => {
        const visibleCount = Math.max(1, Number(visibleSlides(window.innerWidth)) || 1);
        pageCount = Math.max(1, slides.length - visibleCount + 1);
        activeIndex = Math.min(activeIndex, pageCount - 1);

        if (window.innerWidth >= hideControlsAt) {
            track.style.transform = '';
            controls.hidden = true;
            return;
        }

        controls.hidden = pageCount <= 1;
        if (controls.hidden) {
            activeIndex = 0;
        }

        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
        const slideWidth = slides[0].getBoundingClientRect().width;
        const offset = (slideWidth + gap) * activeIndex;
        track.style.transform = `translateX(-${offset}px)`;

        if (dotsNode.childElementCount !== pageCount) {
            createDots();
        }

        updateControls();
    };

    const goPrev = () => {
        if (activeIndex <= 0) {
            return;
        }

        activeIndex -= 1;
        render();
    };

    const goNext = () => {
        if (activeIndex >= pageCount - 1) {
            return;
        }

        activeIndex += 1;
        render();
    };

    prevButton.addEventListener('click', goPrev);
    nextButton.addEventListener('click', goNext);

    let touchStartX = 0;
    viewport.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? 0;
    }, {passive: true});

    viewport.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX ?? 0;
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) < 45) {
            return;
        }

        if (delta < 0) {
            goNext();
            return;
        }

        goPrev();
    }, {passive: true});

    window.addEventListener('resize', render);
    render();

    return {render};
}
